import { ERP } from '../_base/endpoint';
import axios from 'axios';

class formaPagoService {
    
    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}administracion/forma-pago`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new formaPagoService();